/**
 * ASCII Art for Automagik CLI - Adapted from gemini-cli structure
 */

export const shortAutomagikAsciiLogo = `
  ██████╗██╗   ██╗████████╗ ██████╗ ███╗   ███╗ █████╗  ██████╗ ██╗██╗  ██╗
 ██╔══██╗██║   ██║╚══██╔══╝██╔═══██╗████╗ ████║██╔══██╗██╔════╝ ██║██║ ██╔╝
 ██████╔╝██║   ██║   ██║   ██║   ██║██╔████╔██║███████║██║  ███╗██║█████╔╝
 ██╔══██╗██║   ██║   ██║   ██║   ██║██║╚██╔╝██║██╔══██║██║   ██║██║██╔═██╗
 ██║  ██║╚██████╔╝   ██║   ╚██████╔╝██║ ╚═╝ ██║██║  ██║╚██████╔╝██║██║  ██╗
 ╚═╝  ╚═╝ ╚═════╝    ╚═╝    ╚═════╝ ╚═╝     ╚═╝╚═╝  ╚═╝ ╚═════╝ ╚═╝╚═╝  ╚═╝
`;

export const longAutomagikAsciiLogo = `
  ██████╗██╗   ██╗████████╗ ██████╗ ███╗   ███╗ █████╗  ██████╗ ██╗██╗  ██╗
 ██╔══██╗██║   ██║╚══██╔══╝██╔═══██╗████╗ ████║██╔══██╗██╔════╝ ██║██║ ██╔╝
 ██████╔╝██║   ██║   ██║   ██║   ██║██╔████╔██║███████║██║  ███╗██║█████╔╝
 ██╔══██╗██║   ██║   ██║   ██║   ██║██║╚██╔╝██║██╔══██║██║   ██║██║██╔═██╗
 ██║  ██║╚██████╔╝   ██║   ╚██████╔╝██║ ╚═╝ ██║██║  ██║╚██████╔╝██║██║  ██╗
 ╚═╝  ╚═╝ ╚═════╝    ╚═╝    ╚═════╝ ╚═╝     ╚═╝╚═╝  ╚═╝ ╚═════╝ ╚═╝╚═╝  ╚═╝
`;